@if (paginationInfo()?.totalNumberOfResults > 0) {
  <div class="sh-pagination">
    <div class="sh-pagination__page-size-selector">
      <select id="pages" class="sh-select" [formControl]="resultsPerPageControl">
        @for (option of resultsPerPageOptions; track option) {
          <option [value]="option">{{ option }}</option>
        }
      </select>
      <label for="pages" class="sh-pagination__page-size-selector__label">{{ perPageMsg }}</label>
    </div>
    <div class="sh-pagination__actions">
      <sh-action-item [item]="$previousPageActionItem()"></sh-action-item>

      <ng-container *ngTemplateOutlet="pageNav; context: { page: 0 }"></ng-container>

      @if ($currentPage() >= 4 && $maxPage() > 5) {
        <ng-container *ngTemplateOutlet="separator"></ng-container>
      }

      @for (page of $otherPageIndicators(); track page) {
        <ng-container *ngTemplateOutlet="pageNav; context: { page }"></ng-container>
      }

      @if ($currentPage() < $maxPage() - 3 && $maxPage() > 5) {
        <ng-container *ngTemplateOutlet="separator"></ng-container>
      }

      @if ($maxPage() !== 0) {
        <ng-container *ngTemplateOutlet="pageNav; context: { page: $maxPage() }"></ng-container>
      }

      <sh-action-item [item]="$nextPageActionItem()"></sh-action-item>
    </div>
  </div>
}

<ng-template #pageNav let-page="page">
  @if (page === $currentPage()) {
    <b class="sh-pagination__actions__page">{{ page + 1 }}</b>
  } @else {
    <a class="sh-link sh-pagination__actions__page" (click)="navigateToPage(page)">
      {{ page + 1 }}
    </a>
  }
</ng-template>

<ng-template #separator>
  <span class="sh-pagination__actions__page">...</span>
</ng-template>
